module.exports = __webpack_public_path__ + "static/media/Femcare uses telemedicine software for digital healthcare.6f643fcd.webp";